// extracted by mini-css-extract-plugin
export default {"container":"WidgetCard_container__cjCPW"};